import { base_url } from "Backend/api";
import { registerFcmToken } from "Backend/registerFcmToken";
import { getFcmToken } from "getFcmToken";

export async function patchNotificationSettings(notificationsEnabled, authToken) {
  const response = await fetch(`${base_url}/api/notifications/settings`, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${authToken}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ notifications_enabled: notificationsEnabled }),
  });

  const data = await response.json().catch(() => ({}));
  return { ok: response.ok, status: response.status, data };
}

/** Same as Flutter `syncWithBackendAfterOsGrant` */
export async function syncNotificationsWithBackendAfterOsGrant(authToken) {
  if (!authToken) return { ok: false };

  try {
    const fcmToken = await getFcmToken();
    if (fcmToken) {
      await registerFcmToken(fcmToken, authToken);
    }

    const { ok, data } = await patchNotificationSettings(true, authToken);
    if (ok) {
      localStorage.setItem("notifications_enabled", "1");
    }
    return { ok, data };
  } catch {
    return { ok: false };
  }
}

/**
 * Toggle notifications on/off — mirrors Flutter `toggleNotification`.
 * @returns {{ ok: boolean, enabled?: boolean, message?: string }}
 */
export async function toggleNotificationPreference(nextEnabled, authToken) {
  if (!authToken) {
    return { ok: false, message: "يجب تسجيل الدخول أولاً" };
  }

  if (nextEnabled) {
    if (typeof Notification === "undefined") {
      return {
        ok: false,
        message: "المتصفح لا يدعم الإشعارات",
      };
    }

    const fcmToken = await getFcmToken();

    if (Notification.permission !== "granted") {
      return {
        ok: false,
        message: "يجب تفعيل الإشعارات من إعدادات المتصفح",
      };
    }

    if (fcmToken) {
      await registerFcmToken(fcmToken, authToken);
    }
  }

  const { ok, status, data } = await patchNotificationSettings(
    nextEnabled,
    authToken
  );

  if (ok || status === 200) {
    const enabled =
      typeof data?.data?.notifications_enabled === "boolean"
        ? data.data.notifications_enabled
        : nextEnabled;

    localStorage.setItem(
      "notifications_enabled",
      enabled ? "1" : "0"
    );

    return {
      ok: true,
      enabled,
      message: data?.message || "تم تحديث الإشعارات",
    };
  }

  return {
    ok: false,
    message:
      data?.message ||
      (nextEnabled ? "فشل تفعيل الإشعارات" : "فشل إيقاف الإشعارات"),
  };
}
